module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Normal",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_vm._v("To Tracy Timmons-Gray. Thank you for your kindness, and the challenge to write a story where the romance is the subplot.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("To Siobhan Muir, the brilliant mind and sharp eyes behind Thursday Threads and Teddy Bear Thursdays. This story would never have been written without you.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 60
// module chunks = 0